var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthWrongBase',[_vm._v(" Lo sentimos, pero en estos momentos no puedes acceder a la aplicación ")])}
var staticRenderFns = []

export { render, staticRenderFns }